<template>
  <div class="check-details">
    <div class="title">{{ title }}</div>
    <div class="table">
      <div class="table-top">
        <div class="items">{{ $t('selfcheck.contents') }}</div>
        <div class="quantities">{{ $t('selfcheck.quantity') }}</div>
      </div>
      <div v-for="(checkInfo, index) in checkInfos" :key="index" class="line">
        <div class="item">{{ checkInfo.productKbnName }}</div>
        <div class="quantity">{{ checkInfo.counts }}</div>
      </div>
    </div>

    <div class="total">
      <div class="total-label">{{ $t('selfcheck.totalAmount') }}</div>
      <div class="total-value">
        {{ getPriceWithUnit(taxAmount) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckDetails',
  props: {
    title: {
      type: String,
      required: true,
    },
    checkInfos: {
      type: Array,
      required: true,
    },
    taxAmount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
  },
  methods: {
    getPriceWithUnit(price) {
      switch (this.defaultLanguage) {
        case 'ja':
          return `${price.toLocaleString()}${this.$t('common.yen')}`
        case 'zh-tw':
          return `${price.toLocaleString()}${this.$t('common.twGen')}`
        case 'zh-cn':
          return `${price.toLocaleString()}${this.$t('common.cnGen')}`
        case 'us':
          return `${this.$t('common.dollar', { price: (price / 100).toLocaleString() })}`
        default:
          return this.$t('common.yen')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.check-details {
  width: 100%;
  padding: 30px;
  background: #f2f2f2;
  border-radius: 20px;
  font-size: 26px;
  color: #222;

  .title {
    font-size: 22px;
  }
  .table {
    margin: 10px 0;
  }
  .table-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    border-bottom: 1px solid#999;
  }
  .items {
    flex-grow: 1;
    padding: 5px 0;
    font-size: 14px;
  }
  .quantities {
    width: 70px;
    padding: 5px 20px;
    font-size: 14px;
  }
  .line {
    display: flex;
    justify-content: space-between;
  }
  .item {
    flex-grow: 1;
    padding: 5px 0;
    font-size: 16px;
  }
  .quantity {
    width: 70px;
    padding: 5px 20px;
    font-size: 16px;
  }
  .total {
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    .total-label {
      font-size: 14px;
    }
    .total-value {
      font-size: 26px;
    }
  }
}
</style>
